
import {
  UsuarioPerfil
} from '../index';


export class ImpersonatePerfilManutencao {
  "ImpersonateId";
  "UsuarioPerfilId";
  "id";
  Perfil;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ImpersonatePerfilManutencao`.
   */
  static getModelName() {
    return "ImpersonatePerfilManutencao";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ImpersonatePerfilManutencao for dynamic purposes.
  **/
  static factory(data) {
    return new ImpersonatePerfilManutencao(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ImpersonatePerfilManutencao',
      plural: 'ImpersonatePerfilManutencaos',
      path: 'ImpersonatePerfilManutencaos',
      properties: {
        "ImpersonateId": {
          name: 'ImpersonateId',
          type: 'number'
        },
        "UsuarioPerfilId": {
          name: 'UsuarioPerfilId',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Perfil: {
          name: 'Perfil',
          type: 'UsuarioPerfil',
          model: 'UsuarioPerfil'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ImpersonatePerfilManutencao.js